// extracted by mini-css-extract-plugin
module.exports = {"container":"Container-module--container--1baDV","narrow":"Container-module--narrow--3hugD"};